export default __webpack_public_path__ + "static/media/logo.aea7dafc.png";